export default __webpack_public_path__ + "c9b5138eba601a4689753c00f3595576.svg";